import React from 'react'
import PropTypes from 'prop-types'
import {reduxForm, Field} from 'redux-form'
import {Button, Tooltip, ClearIcon} from 'rambler-ui'
import RowButton from 'components/RowButton'
import InlineForm from 'components/InlineForm'
import GenderField from 'components/GenderField'

function ChangeGender({submitting, buttonTooltip, onClose, handleSubmit}) {
  return (
    <InlineForm onSubmit={handleSubmit}>
      <Field
        component={GenderField}
        name="gender"
        format={(value) => value}
        clearable
      />
      <Tooltip
        position="bottom"
        content={buttonTooltip}
        isOpened={!!buttonTooltip}>
        <Button
          type="primary"
          buttonType="submit"
          tabIndex="0"
          loading={submitting}
          disabled={submitting}>
          Сохранить
        </Button>
      </Tooltip>
      <RowButton label="Закрыть" onClick={onClose}>
        <ClearIcon />
      </RowButton>
    </InlineForm>
  )
}

ChangeGender.propTypes = {
  submitting: PropTypes.bool,
  buttonTooltip: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired
}

export default reduxForm({form: 'changeGender'})(ChangeGender)
